import { render, staticRenderFns } from "./PreludesFilter.vue?vue&type=template&id=21d811c8&"
import script from "./PreludesFilter.vue?vue&type=script&lang=ts&"
export * from "./PreludesFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports